import React, { useCallback, useMemo, useState } from "react";
import { IdeCompany } from "./IdeAPI";
import { IdeChooser, IdeChooserProps } from "./IdeChooser";
import BaseField, { BaseFieldProps } from "../components/BaseField";
import { PressableWithFocus } from "../components/PressableWithFocus";
import { TextInput } from "react-native";

export type IdeFieldProps = Omit<BaseFieldProps, "component" | "hasValue" | "value"> &
    Omit<IdeChooserProps, "onDismiss" | "isVisible"> & {
        value?: IdeCompany;
        asListAction?: boolean;
    };

export const IdeField = ({
    value,
    onSelect,
    disabled = false,
    label,
    placeholder,
    error,
    testID,
    asListAction,
    ref,
    ...props
}: IdeFieldProps & { ref?: React.Ref<TextInput> }) => {
    const [chooserVisible, setChooserVisible] = useState(false);

    const handleSelect = useCallback(
        (company: IdeCompany) => {
            setChooserVisible(false);
            onSelect?.(company);
        },
        [onSelect],
    );

    const valueLabel = useMemo(() => value?.name || "", [value]);
    return (
        <>
            <BaseField
                label={label}
                placeholder={placeholder}
                value={valueLabel}
                disabled={disabled}
                error={error}
                asListAction={asListAction}
                testID={testID}
                asButton
                componentRef={ref}
                component={
                    <PressableWithFocus
                        disabled={disabled}
                        onPress={() => {
                            setChooserVisible(true);
                        }}
                    />
                }
            />
            <IdeChooser
                onDismiss={() => setChooserVisible(false)}
                isVisible={chooserVisible}
                onSelect={handleSelect}
                {...props}
            />
        </>
    );
};

export default IdeField;
